<!--
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:12:58
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-10-18 17:14:56
 * @FilePath: \git\xht-web-business\src\views\CouponCreate2.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="wrap">
    <div class="nav"><span class="back" @click="$router.push('/coupon')">&#8592;</span><span class="title">创建优惠券</span></div>
    <div class="card"><div class="label">停车场名称</div><div class="field" style="padding:12px 16px;">
      <div class="parking-display">{{ fixedParkingName || '未选择停车场' }}</div>
    </div></div>
    <div class="card"><div class="label">优惠券名称<span style="color:#ff4444;">*</span></div><input class="input" v-model="form.couponName" placeholder="请输入优惠券名称" /></div>
    <div class="card">
      <div class="label">优惠类型</div>
      <div class="radios">
        <label><input type="radio" name="type2" value="cash" v-model="form.couponType">金额券</label>
        <label><input type="radio" name="type2" value="time" v-model="form.couponType">时长券</label>
      </div>
    </div>
    <div class="card" v-if="form.couponType==='cash'">
      <div class="label">代金券金额（元）</div>
      <input class="input center red" v-model="form.cashAmount" type="number" min="0" step="0.01" placeholder="例如：5" />
    </div>
    <div class="card" v-if="form.couponType==='time'">
      <div class="label">时长（分钟）</div>
      <input class="input center" v-model.number="form.durationMinutes" type="number" placeholder="例如：120" />
    </div>
    <div class="card">
      <div class="label">生效时间</div>
      <input class="input" v-model="form.effectiveTime" type="datetime-local" />
      <div class="label" style="margin-top:12px;">过期时间</div>
      <input class="input" v-model="form.expireTime" type="datetime-local" />
    </div>
    <div class="card">
      <div class="label">领取限制</div>
      <div class="radios">
        <label><input type="radio" name="limit" value="none" v-model="form.limitType">不限制</label>
        <label><input type="radio" name="limit" value="period" v-model="form.limitType">领取周期</label>
      </div>
      <div v-if="form.limitType==='period'" style="margin-top:12px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
        <select class="input small" v-model="form.claimPeriodType" style="width:100px;">
          <option value="DAY">天</option>
          <option value="WEEK">周</option>
          <option value="MONTH">月</option>
        </select>
        <span>内可领取</span>
        <input class="input small" v-model.number="form.claimPeriodCount" type="number" min="1" placeholder="请输入" style="width:120px;" />
        <span>张</span>
      </div>
      <div v-if="form.limitType==='period'" style="color:#8c8c8c;font-size:12px;margin-top:8px;">
        *例如：天100张，表示1天内最多可领取100张
      </div>
    </div>
    <div class="card">
      <div class="label">是否可以叠加使用</div>
      <div class="radios">
        <label><input type="radio" name="canStack" :value="true" v-model="form.canStack">是</label>
        <label><input type="radio" name="canStack" :value="false" v-model="form.canStack">否</label>
      </div>
      <div v-if="form.canStack" class="label" style="margin-top:12px;">最大叠加数量</div>
      <input v-if="form.canStack" class="input center" v-model.number="form.maxStackCount" type="number" min="1" max="99" placeholder="请输入1-99" />
    </div>
    <div class="actions"><button class="btn blue" @click="confirm">确定</button><button class="btn" @click="$router.push('/coupon')">取消</button></div>
  </div>
</template>

<script>
import { createCoupon } from '@/api/coupon'
import { getMyBusinessDetail } from '@/api/business'
import request from '@/utils/request'
export default {
  name: 'CouponCreate2',
  data () {
    return {
      // 固定的停车场信息（从路由参数获取，不可修改）
      fixedParkingName: '',
      fixedParkingId: null,
      fixedParkingType: null, // 'parking' 或 'road'
      // 当前商户ID
      currentBusinessId: null,
      form: {
        couponName: '',
        couponType: 'cash',
        cashAmount: '5',
        durationMinutes: 120,
        effectiveTime: '',
        expireTime: '',
        limitType: 'none',
        claimPeriodType: 'DAY', // 周期类型：DAY/WEEK/MONTH
        claimPeriodCount: 1, // 周期内可领取的数量
        // 叠加使用相关
        canStack: false,
        maxStackCount: 1
      }
    }
  },
  async mounted () {
    // 从路由参数获取固定的停车场信息
    const query = this.$route.query
    if (query.label) {
      // 使用传递过来的标签（包含名称和地址）
      this.fixedParkingName = query.label
    } else if (query.parkingName) {
      // 如果有单独的停车场名称，使用它
      this.fixedParkingName = query.parkingName
    }
    
    // 保存停车场ID和类型，用于提交时使用
    if (query.value) {
      this.fixedParkingId = query.value
    } else if (query.parkingId) {
      this.fixedParkingId = query.parkingId
    }
    
    if (query.type) {
      this.fixedParkingType = query.type
    }
    
    // 如果没有传递停车场信息，提示并返回
    if (!this.fixedParkingName) {
      alert('未选择停车场，请从优惠券页面选择停车场后再创建')
      this.$router.push('/coupon')
      return
    }
    
    // 获取当前商户ID
    await this.fetchBusinessId()
  },
  methods: {
    // 获取当前商户ID
    async fetchBusinessId () {
      try {
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const token = localStorage.getItem('token')
          if (token) {
            try {
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        if (!userId) {
          console.warn('未找到用户ID，无法获取商户信息')
          return
        }
        
        const merchantRes = await request({
          url: '/market/business/list',
          method: 'post',
          data: { administor: userId },
          timeout: 30000
        })
        const merchantList = merchantRes?.data || []
        if (merchantList.length > 0) {
          this.currentBusinessId = merchantList[0].businessId
        }
      } catch (e) {
        console.error('获取商户信息失败:', e)
      }
    },
    async confirm () {
      // 简单校验
      if (!this.form.couponName) { alert('请输入优惠券名称'); return }
      
      // 校验优惠券类型对应的面值
      if (this.form.couponType === 'cash') {
        const amount = Number(String(this.form.cashAmount).replace(/[^\d.]/g, ''))
        if (!amount || amount <= 0) { alert('请输入有效的代金券金额'); return }
      } else if (this.form.couponType === 'time') {
        const minutes = Number(this.form.durationMinutes)
        if (!minutes || minutes <= 0) { alert('请输入有效的时长（分钟）'); return }
      }
      
      // 校验领取限制
      if (this.form.limitType === 'period') {
        if (!this.form.claimPeriodType) {
          alert('请选择领取周期类型')
          return
        }
        if (!this.form.claimPeriodCount || this.form.claimPeriodCount <= 0) {
          alert('请输入有效的领取数量（必须大于0）')
          return
        }
      }
      
      if (this.form.effectiveTime && this.form.expireTime && new Date(this.form.effectiveTime) > new Date(this.form.expireTime)) {
        alert('过期时间必须晚于生效时间');
        return
      }
      
      // 检查是否有商户ID
      if (!this.currentBusinessId) {
        alert('未找到商户信息，无法创建优惠券')
        return
      }
      
      // 检查是否有停车场ID
      if (!this.fixedParkingId) {
        alert('未选择停车场，无法创建优惠券')
        return
      }
      
      // 映射提交数据到后端（按照平台侧格式）
      const now = new Date()
      const oneYearLater = new Date(now.getTime() + 365*24*60*60*1000)
      const effectiveTime = this.form.effectiveTime ? new Date(this.form.effectiveTime) : now
      const expirationTime = this.form.expireTime ? new Date(this.form.expireTime) : oneYearLater
      
      // 根据优惠券类型计算面值
      let couponPrice = null
      let couponFreeMinutes = null
      
      if (this.form.couponType === 'cash') {
        // 金额券：元转分
        const amount = Number(String(this.form.cashAmount).replace(/[^\d.]/g, ''))
        couponPrice = Math.round(amount * 100)
      } else if (this.form.couponType === 'time') {
        // 时长券：分钟数
        couponFreeMinutes = Math.round(Number(this.form.durationMinutes))
      }
      
      // 计算商家支付单价
      let businessPayment = 0
      if (this.form.couponType === 'cash' && this.currentBusinessId) {
        // 代金券：根据商户折扣计算
        try {
          const amount = Number(String(this.form.cashAmount).replace(/[^\d.]/g, ''))
          // 获取商户详情，查看是否开启商户折扣
          const businessDetail = await getMyBusinessDetail(this.currentBusinessId)
          const merchantDiscount = businessDetail?.data?.merchantDiscount
          
          // 判断是否开启商户折扣：merchantDiscount 不为 null 且小于 100 表示开启了折扣
          if (merchantDiscount != null && Number(merchantDiscount) < 100) {
            // 开启了商户折扣：商家支付单价 = 代金券金额 * (折扣率 / 100)
            // merchantDiscount 是百分比（0-100），需要除以 100 转换为小数
            const discountRatio = Number(merchantDiscount) / 100
            businessPayment = amount * discountRatio
          } else {
            // 未开启商户折扣：商家支付单价 = 代金券金额
            businessPayment = amount
          }
        } catch (e) {
          console.error('获取商户详情失败，使用默认值（代金券金额）:', e)
          // 获取失败时，默认使用代金券金额
          const amount = Number(String(this.form.cashAmount).replace(/[^\d.]/g, ''))
          businessPayment = amount
        }
      } else if (this.form.couponType === 'time' && this.fixedParkingId) {
        // 时长券：根据计费规则计算
        try {
          const minutes = Number(this.form.durationMinutes)
          if (minutes > 0) {
            // 获取停车场的计费规则
            const res = await request({
              url: '/order/park/rel/billing/rule/groups/list/billing-rule/by-park',
              method: 'get',
              params: { parkId: this.fixedParkingId }
            })
            const rules = Array.isArray(res?.data) ? res.data : []
            // 选择支持按时计费的第一条规则
            const rule = rules.find(r => r.isSupportTimeCharge === true || r.isSupportTimeCharge === 'true') || rules[0]
            
            if (rule) {
              // 根据计费规则计算金额
              const baseAmount = this.estimateAmountByRule(minutes, rule)
              if (baseAmount > 0) {
                // 获取商户详情，查看是否开启商户折扣
                if (this.currentBusinessId) {
                  try {
                    const businessDetail = await getMyBusinessDetail(this.currentBusinessId)
                    const merchantDiscount = businessDetail?.data?.merchantDiscount
                    
                    // 判断是否开启商户折扣
                    if (merchantDiscount != null && Number(merchantDiscount) < 100) {
                      // 开启了商户折扣：商家支付单价 = 基础金额 * (折扣率 / 100)
                      const discountRatio = Number(merchantDiscount) / 100
                      businessPayment = baseAmount * discountRatio
                    } else {
                      // 未开启商户折扣：商家支付单价 = 基础金额
                      businessPayment = baseAmount
                    }
                  } catch (e) {
                    console.error('获取商户详情失败，使用基础金额:', e)
                    businessPayment = baseAmount
                  }
                } else {
                  businessPayment = baseAmount
                }
              }
            } else {
              console.warn('未找到计费规则，商家支付单价设为0')
              businessPayment = 0
            }
          }
        } catch (e) {
          console.error('获取计费规则失败，商家支付单价设为0:', e)
          businessPayment = 0
        }
      }
      
      // 构建payload（按照平台侧格式）
      const couponData = {
        couponType: this.form.couponType === 'cash' ? 'CASH' : 'TIME',
        couponName: this.form.couponName,
        couponDescription: '',
        couponPrice: couponPrice,
        couponDiscountRate: null,
        couponFreeMinutes: couponFreeMinutes,
        couponTotalNumber: 100, // 默认总数量
        isSupportMultipleUse: this.form.canStack || false,
        maxMultipleUseTimes: this.form.canStack ? (this.form.maxStackCount || 1) : 1,
        maxUseTimesPerDay: 1,
        couponValidityDurationStart: effectiveTime.toISOString(),
        couponValidityDurationEnd: expirationTime.toISOString(),
        // 领取限制
        claimLimitType: this.form.limitType === 'period' ? 'PERIOD_LIMIT' : 'NO_LIMIT',
        claimPeriodType: this.form.limitType === 'period' ? this.form.claimPeriodType : null,
        claimPeriodCount: this.form.limitType === 'period' && this.form.claimPeriodCount ? Number(this.form.claimPeriodCount) : null,
        couponValidityDuration: null,
        couponValidityDurationType: null,
        businessId: this.currentBusinessId, // 使用UUID格式的businessId
        parkIds: [this.fixedParkingId], // 停车场ID数组
        businessPayment: businessPayment, // 商家支付单价（元），代金券根据商户折扣计算，时长券默认为0
        deductionType: 'AFTER_EXIT', // 扣除方式，默认出场后扣除
        salePrice: null, // 售卖价格（分），按张数售卖时才需要
        billingMethod: null, // 计费方式（仅全免券）
        specifiedAmount: null // 指定金额（分，仅当计费方式为指定金额扣除时）
      }

      try {
        const res = await createCoupon(couponData)
        console.log('创建优惠券成功:', res)
        
        alert('创建成功')
        this.$router.push('/coupon')
      } catch (e) {
        console.error('创建优惠券失败:', e)
        const errorMsg = e?.response?.data?.message || e?.message || '创建失败，请稍后重试'
        alert(`创建失败：${errorMsg}`)
      }
    },
    // 根据计费规则和时长（分钟）估算金额（元）
    estimateAmountByRule (minutes, rule) {
      const dur = Math.max(0, Math.round(Number(minutes) || 0))
      if (!rule || dur <= 0) return 0
      // 字段兼容
      const unitMin = rule.timeChargeUnitMinutes ?? rule.unitMinutes ?? 0
      const unitPrice = Number(rule.timeChargeUnitPriceYuan ?? rule.timeChargeUnitPrice ?? rule.unitPriceYuan ?? rule.unitPrice ?? 0)
      const stepMin = rule.timeChargeStepUnitMinutes ?? rule.stepUnitMinutes ?? unitMin
      const stepPrice = Number(rule.timeChargeStepUnitPriceYuan ?? rule.timeChargeStepUnitPrice ?? rule.stepUnitPriceYuan ?? rule.stepUnitPrice ?? unitPrice)
      const maxAmount = Number(rule.timeChargeMaxAmount ?? rule.maxAmount ?? 0)

      if (unitMin <= 0 || stepMin <= 0 || unitPrice < 0 || stepPrice < 0) return 0

      let remaining = dur
      let amount = 0
      // 首段
      remaining -= unitMin
      amount += unitPrice
      // 后续阶梯
      while (remaining > 0) {
        remaining -= stepMin
        amount += stepPrice
        // 防止极端情况下死循环
        if (amount > 1e8) break
      }
      if (isFinite(maxAmount) && maxAmount > 0 && amount > maxAmount) amount = maxAmount
      return Math.max(0, Number(amount.toFixed(2)))
    },
    generateCouponCode () {
      // 规则：CP + yyyyMMddHHmmss + '_' + 随机三位/四位
      const pad = (n, w=2) => String(n).padStart(w,'0')
      const d = new Date()
      const ts = `${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`
      const rnd = Math.floor(Math.random()*900)+100
      return `CP${ts}_${rnd}`
    }
  }
}
</script>

<style scoped>
.wrap {
  max-width:430px;
  margin:0 auto;
  background:#f7f8fa;
  min-height:100vh;
  padding-bottom:80px;
}

.nav {
  height:56px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:#fff;
  box-shadow:0 1px 0 #f0f0f0;
  position:relative;
}

.back {
  position:absolute;
  left:0;
  padding-left:16px;
  font-size:26px;
  cursor:pointer;
}

.title {
  font-size:20px;
  font-weight:bold;
}

.card {
  background:#fff;
  border-radius:16px;
  margin:18px 16px 0;
  padding:18px 16px;
  box-shadow:0 2px 8px #f0f0f0;
}

.label {
  font-size:15px;
  color:#bbb;
  margin-bottom:6px;
}

.field {
  background:#f7f8fa;
  border-radius:10px;
  padding:12px 16px;
  font-size:17px;
  color:#222;
}
.field.row { display:flex; align-items:center; justify-content:space-between; }

.input {
  width:100%;
  background:#f7f8fa;
  border:none;
  border-radius:10px;
  padding:12px 16px;
  font-size:17px;
  color:#222;
  outline:none;
}
.input.center { text-align:center; }
.input.red { color:#ff4444; }
.input.small { width:60px; padding:6px 8px; font-size:16px; border-radius:8px; }
select.input { width:100%; background:#f7f8fa; border:none; border-radius:10px; padding:12px 16px; font-size:17px; color:#222; outline:none; cursor:pointer; }
select.input.small { width:100px; padding:8px 12px; font-size:16px; border-radius:8px; }

/* 可搜索下拉样式 */
.select-wrapper { position: relative; }
.select-input { width: 100%; box-sizing: border-box; border: none; outline: none; background: #f7f8fa; padding: 12px 16px; border-radius: 10px; font-size: 16px; }
.select-display { display:none; }
.dropdown { position: absolute; top: 48px; left: 0; right: 0; background: #fff; border: 1px solid #eee; border-radius: 10px; max-height: 220px; overflow: auto; box-shadow: 0 6px 20px rgba(0,0,0,0.08); z-index: 10; }
.option { padding: 10px 12px; cursor: pointer; }
.option:hover { background: #f5f7fa; }
.option.empty { color: #999; cursor: default; }

.parking-display {
  font-size: 17px;
  color: #222;
  word-break: break-all;
}

.actions {
  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
  margin:38px 16px 0;
}

.btn {
  flex:1;
  background:#fff;
  color:#888;
  font-size:20px;
  font-weight:bold;
  border:none;
  border-radius:14px;
  padding:16px 0;
  box-shadow:0 2px 8px #eee;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.btn.blue {
  background:#238aff;
  color:#fff;
}

.btn:active {
  transform: scale(0.98);
}

.radios label {
  margin-right:18px;
  font-size:16px;
}
</style>
